// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".no-connection[data-v-449cb4b4]{left:16px;bottom:16px;z-index:1000;position:fixed}.no-connection__text[data-v-449cb4b4]{line-height:1;margin-top:1px;font-size:14px;font-weight:bold;margin-left:8px}.no-connection__icon[data-v-449cb4b4]{width:24px}.no-connection .toast[data-v-449cb4b4]{display:flex;align-items:center}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
